import GetRole from './GetRole';
import { ADMIN_ROLE, ARTIST_ROLE, THEATER_ADMIN_ROLE } from '../constants';
import GetToken from './GetToken';

export const IsTheaterAdmin = () => GetToken() && GetRole().toUpperCase() === THEATER_ADMIN_ROLE;
export const IsArtist = () => GetToken() && GetRole().toUpperCase() === ARTIST_ROLE;
export const IsAdmin = () => GetToken() && GetRole().toUpperCase() === ADMIN_ROLE;



// WEBPACK FOOTER //
// ./src/utils/Roles.js